import styled from 'styled-components';
import { transparentize } from 'utils/color';
import media from 'components/mixins/media';

/* eslint-disable import/prefer-default-export */
export const Container = styled.div``;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  ${media.mobile`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 40px 20px;
    border: 2px solid ${props => transparentize(props.theme.colors.textColor, 0.02)};
  `};
`;

export const TitleContainer = styled.div`
  display: flex;
  width: 100%;
  align-items: flex-start;

  ${media.mobile`
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
  `};
`;

export const IconWrapper = styled.div`
  position: relative;
  padding-right: 13px;
  margin-right: 12px;
  opacity: 0.4;

  &::after {
    content: '';
    position: absolute;
    display: block;
    right: 0;
    top: 8px;
    width: 1px;
    height: 16px;
    background: rgba(25, 25, 25, 0.2);
  }

  ${media.mobile`
    padding-right: 0;
    margin-right: 0;
    margin-bottom: 20px;

    &::after {
      display: none;
    }
  `};
`;

export const TextWrapper = styled.div`
  width: 100%;

  h4 {
    margin: 0;
    margin-top: -4px;
    word-break: break-word;
  }

  ${media.mobile`
    margin: 0;
  `};
`;

export const ButtonContainer = styled.div`
  margin-left: 25px;
  margin-top: 6px;

  ${media.mobile`
    margin-top: 20px;
    margin-left: 0;
  `};
`;

export const IframeContainer = styled.div`
  margin-top: 32px;

  ${media.mobile`
    margin-top: 4px;
  `};
`;

export const Iframe = styled.iframe`
  iframe& {
    border: 1px solid ${props => transparentize(props.theme.colors.textColor, 0.02)};
  }
`;
